import "./styles/app.css";
import { createUi } from "@amtana/browser";

import { browserModules } from "./browser-modules.generated.ts";

createUi({ mount: "root" }).withModules(browserModules).render();
